export const MHeaderElements = [
  { label: "Tipo", value: "tipo", align: "inherit" },
  { label: "Tipo solicitud", value: "tipoSolicitud", align: "inherit" },
  { label: "Descripción", value: "descripcion", align: "inherit" },
];
